import * as React from "react";

export const MessagesIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.5} fillRule="evenodd" clipRule="evenodd" fill="currentColor">
      <path d="M13.295 3.648V5.52H9.239a3.81 3.81 0 0 0-3.81 3.812v2.938l-1.145.823a.623.623 0 0 1-.905-.181.66.66 0 0 1-.1-.325v-.944a2.17 2.17 0 0 1-2.167-2.2V3.648A2.54 2.54 0 0 1 3.65 1.11h7.106a2.54 2.54 0 0 1 2.539 2.54" />
      <path d="M16.351 6.793h-7.11A2.54 2.54 0 0 0 6.7 9.332v5.439a2.54 2.54 0 0 0 2.54 2.539h4.444l2.044 1.46a.638.638 0 0 0 1.006-.521v-.934a2.183 2.183 0 0 0 2.155-2.178V9.332a2.545 2.545 0 0 0-2.539-2.539m-3.666 8.283a.634.634 0 1 1 .598-.388.64.64 0 0 1-.598.388m.65-2.677v.722H12.05v-.795a1.205 1.205 0 0 1 1.2-1.216.494.494 0 0 0 .495-.49.556.556 0 0 0-.556-.61h-.505a.383.383 0 0 0-.384.383v.339h-1.267v-.339A1.667 1.667 0 0 1 12.7 8.726h.506A1.83 1.83 0 0 1 15 10.582a1.784 1.784 0 0 1-1.666 1.816" />
    </g>
  </svg>
);
